import React from "react"
import { graphql } from "gatsby"
import { Layout } from "../components/layout"
import { Seo } from "../components/seo"
import GithubRepo from "../components/github_repo"
import Hero from "../components/hero"

const Opensource = ({ data }) => {
  return (
    <Layout>
      <section className="bg-black bg-blue-grade bg-contain bg-top px-12">
        <article className="py-32">
          <Hero className="text-white tracking-tight" size="text-5xl sm:text-6xl lg:text-8xl">We <span className="gradient-red">❤️ </span> Open Source</Hero>
          <div className="mx-4">
            <div className="text-center sm:px-12 px-2">
              <h2 className="mt-16 text-3xl font-semibold text-gray-300">Open Source Projects Maintained by Cloud 66</h2>
            </div>
          </div>
          <div className="flex flex-wrap justify-center mt-20">
            {data.githubData.data.node.repositories.nodes.map(item => {
              return <GithubRepo key={item.name} repo={item} />
            })}
          </div>

        </article>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query onGithub {
    githubData {
      data {
        node {
          id
          name
          repositories {
            nodes {
              forks {
                totalCount
              }
              languages {
                nodes {
                  name
                  color
                }
              }
              name
              stargazers {
                totalCount
              }
              url
              description
            }
          }
        }
      }
    }
  }
`

export default Opensource

export const Head = () => {
  return (
    <Seo title="Cloud 66 Open Source" />
  )
}
